import { Spin } from "ant-design-vue";
import "./src/spin.less"
const { ...other } = Spin;
const YwSpin = {
  ...other,
  name: "YwSpin",
};

YwSpin.install = function (Vue) {
  Vue.component(YwSpin.name, Spin);
};

export default YwSpin;